import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import styles from './style.module.scss';

const Button = (props) => {
  const { theme, size, children, style, fixedSize, onClick, className } = props;
  return (
    <div
      style={style}
      onClick={onClick}
      className={cls(
        styles.button,
        styles[`theme-${theme}`],
        styles[`size-${size}`],
        className,
        { [styles.fixedSize]: fixedSize },
      )}
    >
      {children}
    </div>
  );
};

Button.propTypes = {
  theme: PropTypes.oneOf(['primary', 'red', 'purple', '']),
  size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  children: PropTypes.any,
  onClick: PropTypes.func,
  fixedSize: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
};

Button.defaultProps = {
  theme: 'default',
  fixedSize: true,
};

export default Button;
